module.exports = __webpack_public_path__ + "fonts/f5dcdf611cdca24914dd2a548009d2ff.svg";